import React from 'react';
import RawPagination from '@deprecated-ui/common/Pagination';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { earningsEffects, earningsSelectors } from 'features/earnings/slice';

const SPaginationEarnings = styled(RawPagination)`
  .ant-pagination-next,
  .ant-pagination-prev {
    padding: 0px 10px;
  }

  .ant-pagination-next:hover,
  .ant-pagination-prev:hover {
    background: ${color.whisper};
    color: ${color.primary};
  }
`;

const itemRender = (current, type, originalElement) => {
  if (type === 'prev') {
    return <div>Prev</div>;
  }
  if (type === 'next') {
    return <div>Next</div>;
  }
  return originalElement;
};

const EarningsPagination = ({
  totalRow,
  currentPage,
}: {
  currentPage: string;
  totalRow: number;
}) => {
  const {
    earnings: {
      data: { order, sortcol, year, quarter, filter, keyword },
    },
  } = useSelector(earningsSelectors);
  const dispatch = useDispatch();

  const onSelectPageHandler = (page) => {
    dispatch(
      earningsEffects.getEarnings({
        page,
        order,
        sortcol,
        year,
        quarter: quarter.toString(),
        companySymbol: keyword || undefined,
        filter,
      }),
    );
  };

  return (
    <SPaginationEarnings
      current={Number(currentPage)}
      defaultPageSize={50}
      total={totalRow}
      showSizeChanger={false}
      itemRender={itemRender}
      onChange={onSelectPageHandler}
    />
  );
};

export default EarningsPagination;
